"use client";

// Tiny mount-only client component, same pattern as SiteVisitTracker /
// FreezeWatchdogClient. Measures and corrects iOS's safe-area-inset values
// on cold start — see lib/safe-area-probe.ts for why this is needed. Renders
// nothing.

import { useEffect } from "react";
import { initSafeAreaProbe } from "@/lib/safe-area-probe";

export default function SafeAreaProbeClient() {
  useEffect(() => {
    initSafeAreaProbe();
  }, []);
  return null;
}
